import Joi from '@hapi/joi'

export const taskSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity Required`,
        "any.required": `Operation Entity Required`
    }),
    taskTypeID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Task Type Required`,
        "any.required": `Task Type Required`
    }),
    estateTaskName: Joi.string().required().label("Task Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Task Name required`,
        "string.pattern.base": `Please enter valid task name`,
    }),
    estateTaskDescription:Joi.string().required().label("Task Description").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Task Description required`,
        "string.pattern.base": `Please enter valid task description`,
    }),
    isActive: Joi.boolean().label("Active")
}














